import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homepage-two',
    templateUrl: './homepage-two.component.html',
    styleUrls: ['./homepage-two.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomepageTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
